import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum PlaceOfPerformance {
  AllAtSubrecipient = 'all-at-subrecipient',
  SomeAtPte = 'some-at-pte',
  AllAtPte = 'all-at-pte',
}

const SUBCONTRACT_PERCENTS: ReadonlySet<PlaceOfPerformance> = new Set(
  Object.values(PlaceOfPerformance) as PlaceOfPerformance[],
)
export namespace PlaceOfPerformance {
  export const ALL: readonly PlaceOfPerformance[] =
    Array.from(SUBCONTRACT_PERCENTS)
  export const isPlaceOfPerformance =
    TypeChecker.Factory.oneOf(SUBCONTRACT_PERCENTS)
  export const assertIsPlaceOfPerformance: TypeAsserter<PlaceOfPerformance> =
    TypeAsserter.Factory.from(isPlaceOfPerformance)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link PlaceOfPerformance}
   */
  export function getEntry(
    placeOfPerformance: PlaceOfPerformance,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[placeOfPerformance], id: placeOfPerformance }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    PlaceOfPerformance,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [PlaceOfPerformance.AllAtSubrecipient]: {
      name: "All work will be performed at the Subrecipient's Institution",
    },
    [PlaceOfPerformance.SomeAtPte]: {
      name: "Some work will be performed at the PTE's Institution",
    },
    [PlaceOfPerformance.AllAtPte]: {
      name: "All work will be performed at the PTE's Institution",
    },
  }
}
